import { render, staticRenderFns } from "./DasDoorOV.vue?vue&type=template&id=6dac3f90&scoped=true&"
import script from "./DasDoorOV.vue?vue&type=script&lang=js&"
export * from "./DasDoorOV.vue?vue&type=script&lang=js&"
import style0 from "./DasDoorOV.vue?vue&type=style&index=0&id=6dac3f90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac3f90",
  null
  
)

export default component.exports